import { z } from "zod";

// Names may contain letters (incl. accented Latin for pt/es locales: À-ÿ),
// spaces, hyphens and apostrophes — but no digits or other symbols.
// Explicit range instead of \p{L} to avoid the ES6-only /u flag.
export const NAME_REGEX = /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]+$/;
export const NAME_ERROR = "Name can only contain letters";

// Shared name field for create/invite forms. Trims, enforces a minimum
// length, then blocks anything that isn't a letter/space/hyphen/apostrophe.
export function nameField(min = 2, label = "Name") {
  return z
    .string()
    .trim()
    .min(min, `${label} must be at least ${min} characters`)
    .regex(NAME_REGEX, NAME_ERROR);
}

// mirror of server/src/common/password-validation.ts
export const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*\d).{8,}$/;
export const PASSWORD_ERROR =
  "Password must be at least 8 characters and include an uppercase letter and a number.";
export const PASSWORD_HINT =
  "At least 8 characters, with an uppercase letter and a number.";

// Shared field for every form that sets a password (never login).
export function passwordField() {
  return z.string().regex(PASSWORD_REGEX, PASSWORD_ERROR);
}
